


































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  List,
  Checkbox,
  CheckboxGroup,
  Button,
  Lazyload,
  Dialog,
  Toast,
} from 'vant';

import { getVoteList } from '../api';

Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Lazyload)
  .use(Dialog)
  .use(Button)
  .use(Toast);

@Component
export default class VoteList extends Vue {
  @Prop() listType!: any;
  @Prop({ default: '' }) search!: any;

  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];

  get words() {
    return this.search;
  }
  // 初使加载
  async onLoad() {
    this.loading = true;

    const res = await getVoteList(this.listType, this.page, this.words);
    this.fetchListData(res);
  }
  fetchListData(res: any) {
    if (res.status === 1 || res.code === 500 || res.msg === '暂无数据') {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
      this.finished = false;
    }
    this.loading = false;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    this.$emit('enterDetailPage', item.id);
  }

  @Watch('search')
  onSearchChanged() {
    this.loading = false;
    this.finished = false;
    this.page = 1;
    this.getListData = [];
    if (!this.search) {
      return;
    }
    this.onLoad();
  }

  @Watch('listType', {
    immediate: true,
  })
  onListTypeChanged() {
    this.loading = false;
    this.finished = false;
    this.page = 1;
    this.getListData = [];
    this.onLoad();
  }
}
